import { WorkStatusType } from '@amarantos/api-client'

export const issueStatuses = [
	WorkStatusType.damaged,
	WorkStatusType.material_shortage,
	WorkStatusType.other_issue,
] as const satisfies readonly WorkStatusType[]

export type IssueStatus = (typeof issueStatuses)[number]

export function isIssueStatus(status: WorkStatusType): status is IssueStatus {
	return (issueStatuses as readonly WorkStatusType[]).includes(status)
}
